import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=73db82d4&scoped=true&"
import script from "./form-select.vue?vue&type=script&lang=js&"
export * from "./form-select.vue?vue&type=script&lang=js&"
import style0 from "./form-select.vue?vue&type=style&index=0&id=73db82d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db82d4",
  null
  
)

export default component.exports